import { render, staticRenderFns } from "./DaftarKalendar.vue?vue&type=template&id=05c59e5f&scoped=true"
import script from "./DaftarKalendar.vue?vue&type=script&lang=js"
export * from "./DaftarKalendar.vue?vue&type=script&lang=js"
import style0 from "./DaftarKalendar.vue?vue&type=style&index=0&id=05c59e5f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05c59e5f",
  null
  
)

export default component.exports